export const prepareConsentOrderAttributes = (inputObject) => {
    if (!inputObject) {
        return [];
    }
    return Object.entries(inputObject).map(([key, value]) => ({
        attribute_code: key,
        value,
    }));
};
export const prepareOrderAttributes = (input) => {
    return input
        .filter((item) => item.value !== undefined)
        .map(({ code, value }) => ({
        attribute_code: code,
        value: value.toString(),
    }));
};
export const prepareTradeInAttributes = (input) => {
    if (!input) {
        return [];
    }
    return Object.entries(input)
        .map(([key, value]) => ({
        attribute_code: key,
        value: value.toString(),
    }))
        .filter((item) => !!item.value);
};
//# sourceMappingURL=prepareOrderAttributes.js.map